/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { SkinningCustomerDetails, SkinningCustomerList } from './components';

export const SkinningCustomers = () => {
  return (
    <Routes>
      <Route path="/" element={<SkinningCustomerList />} />
      <Route path="/:userId" element={<SkinningCustomerDetails />} />
    </Routes>
  );
};
